import { Component } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
  form = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email])
  });
  message: string | null = null;
  success = false;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private spinner: NgxSpinnerService
  ) {}

  isInvalid(control: AbstractControl): boolean {
    return !!(control && control.touched && control.dirty && !control.valid);
  }

  submit(): void {
    this.message = null;
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    const email = this.form.get('email')?.value?.trim();
    if (!email) {
      this.message = 'Informe o e-mail.';
      return;
    }
    this.spinner.show();
    this.authenticationService.forgotPassword(email).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        this.success = true;
        this.message = (res && res.message) ? res.message : 'Se o e-mail estiver cadastrado, você receberá um link para redefinir a senha.';
      },
      error: (err) => {
        this.spinner.hide();
        const msg = err?.error?.message || err?.message;
        this.message = msg || 'Não foi possível processar. Tente novamente.';
      }
    });
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}
